// extracted by mini-css-extract-plugin
module.exports = {"heroContainer":"BlogHero-module--heroContainer--Yo_a3"};